import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import ProductView from '../../components/ProductView/ProductView'
import Footer from '../../components/Footer/Footer'

const ProductPage = () => {
  return (
    <div className='page__wrappper'>
        <Navbar />
        <div className='auth__container'>
            <ProductView />
        </div>
        <Footer />
    </div>
  )
}

export default ProductPage
